import { gql } from '@apollo/client'

export const SelectedQuery = gql`
  query SelectedEventItemSelector($companyId: ID!, $id: ID) {
    assetTypes(companyId: $companyId, filters: { idEq: $id }) {
      nodes {
        id
        name
        images { id url }
      }
    }
    packages(companyId: $companyId, filters: { idEq: $id }) {
      nodes {
        id
        name
        images { id url }
      }
    }
    rowItems(companyId: $companyId, filters: { idEq: $id }) {
      nodes {
        id
        name
        images { id url }
      }
    }
    vehicles(companyId: $companyId, filters: { idEq: $id }) {
      nodes {
        id
        name
        images { id url }
      }
    }
  }
`

export const Query = gql`
  query EventItemSelector(
    $companyId: ID!,
    $assetTypeFilters: AssetTypeFilters,
    $packageFilters: PackageFilters,
    $rowItemFilters: RowItemFilters,
    $vehicleFilters: VehicleFilters,
    $after: String,
    $before: String,
    $first: Int,
    $last: Int
  ) {
    companies(filters: { idEq: $companyId }) {
      nodes {
        id
        placeholderLogo { id url }
      }
    }
    assetTypes(
      companyId: $companyId,
      filters: $assetTypeFilters,
      after: $after,
      before: $before,
      first: $first,
      last: $last
    ) {
      nodes {
        id
        name
        images { id url }
      }
      pageInfo { startCursor endCursor hasNextPage hasPreviousPage }
    }
    packages(
      companyId: $companyId,
      filters: $packageFilters,
      after: $after,
      before: $before,
      first: $first,
      last: $last
    ) {
      nodes {
        id
        name
        images { id url }
      }
      pageInfo { startCursor endCursor hasNextPage hasPreviousPage }
    }
    rowItems(
      companyId: $companyId,
      filters: $rowItemFilters,
      after: $after,
      before: $before,
      first: $first,
      last: $last
    ) {
      nodes {
        id
        name
        images { id url }
      }
      pageInfo { startCursor endCursor hasNextPage hasPreviousPage }
    }
    vehicles(
      companyId: $companyId,
      filters: $vehicleFilters,
      after: $after,
      before: $before,
      first: $first,
      last: $last
    ) {
      nodes {
        id
        name
        images { id url }
      }
      pageInfo { startCursor endCursor hasNextPage hasPreviousPage }
    }
  }
`
